import { AddIcon } from "../icons/AddIcon";
import { TableIcon } from "../icons/TableIcon";
import Button from "./Buttons/Button";

export default function Pagination() {
  return (
    <div className=" bg-[#F4F7FE] items-center justify-left space-x-2 mt-4">
      <div className="flex my-5 mx-10 gap-2">
        <Button
          onClick={() => {
            console.log("Test");
          }}
        >
          <div className="flex gap-2 text-white bg-[#0832DE] p-2 rounded-sm">
            <TableIcon />
            General Table
          </div>
        </Button>

        <div className="border-l border-[#E3E8EC]" />

        <Button
          onClick={() => {
            console.log("Test");
          }}
        >
          <div className="flex text-black bg-[#E2E7F3] p-2 rounded-sm">
            Свободная таблица
          </div>
        </Button>

        <Button
          onClick={() => {
            console.log("Test");
          }}
        >
          <div className="flex gap-2 text-black bg-[#E2E7F3] p-2 rounded-sm">
            <AddIcon />
          </div>
        </Button>
      </div>
    </div>
  );
}
